"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var linkWrapper_1 = __importDefault(require("./linkWrapper"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useWinnerCard_1 = __importDefault(require("./talons/useWinnerCard"));
var react_transition_group_1 = require("react-transition-group");
var WinnerItem = function (_a) {
    var gameId = _a.gameId, slug = _a.slug, title = _a.title, playerName = _a.playerName, prize = _a.prize, imageUrl = _a.imageUrl, gameCardPlaceholder = _a.gameCardPlaceholder;
    var _b = (0, useWinnerCard_1.default)({ gameId: gameId, slug: slug, gameCardPlaceholder: gameCardPlaceholder }), t = _b.t, hovered = _b.hovered, imageSrc = _b.imageSrc, setImageSrc = _b.setImageSrc, setHovered = _b.setHovered, handleClickOnGame = _b.handleClickOnGame, openGameInfo = _b.openGameInfo;
    return (react_1.default.createElement(react_transition_group_1.Transition, { in: true, timeout: 700, enter: true }, function (state) { return (react_1.default.createElement("div", { className: styles_module_scss_1.default.winnerCardWrapper, style: {
            maxWidth: state === 'entered' ? '220px' : '0px',
            visibility: state === 'entered' ? 'visible' : 'hidden',
            transform: "translateX(".concat(state, " === 'entered' ? '0%' : '-100%')"),
            opacity: "".concat(state === 'entering' ? '0' : '1'),
            marginRight: "".concat(state === 'entered' ? '15px' : '0'),
            marginLeft: "".concat(state === 'entered' ? '15px' : '0'),
        } },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.winnerCardContent },
            react_1.default.createElement(linkWrapper_1.default, { classes: styles_module_scss_1.default.winnerCardImageWrapper, handleClickOnGame: function () { return handleClickOnGame(); }, WrappedComponent: function (_a) {
                    var onClick = _a.onClick;
                    return (react_1.default.createElement(image_1.default, { width: 80, className: styles_module_scss_1.default.gameCardImage, height: 52, src: imageSrc, onLoad: function () {
                            setImageSrc(imageUrl);
                        }, alt: title, placeholder: gameCardPlaceholder, onClick: onClick }));
                }, openInfoModal: openGameInfo }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.winStreakInfo },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.playerName }, playerName),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.winnerCardPrize }, prize),
                react_1.default.createElement("h5", { className: styles_module_scss_1.default.winnerCardInGame },
                    t('translation.in'),
                    " ",
                    title)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.winnerCardHoverButtons },
                react_1.default.createElement("button", { className: styles_module_scss_1.default.playBtn, onClick: function () { return handleClickOnGame(); } }, t('translation.playNow')))))); }));
};
exports.default = (0, react_1.memo)(WinnerItem);
